import { Icon, IconButton, IIconProps, Image, TextField, Link } from '@fluentui/react';
import { fieldValidation, keyPress } from 'app/components/helpers';
import { useQueryAllDeviceList } from 'app/services/request-api';
import defaultDeviceIcon from 'app/static/icons/devices_default_icon.svg';
import { StringConstants } from 'app/utils/constants';
import { getDeviceIcon } from 'app/utils/SVGIcons';
import { DefaultButton, Text } from 'office-ui-fabric-react';
import React, { useEffect, useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import './AddProduct.scss';
import { DeviceCategory, DeviceModel, DeviceModelDto, RequestDto } from 'generated/request-backend';

interface ISearchProps {
    setDisplayScreen?: Function;
    onDismiss?: Function;
    addOrUpdate?: String;
    onSuccessHandler?: Function;
    selectedRequest?: RequestDto;
    handleAddProduct?: () => void;
    setCssNumberText?: (setCssNumber: boolean) => void;
    addedDevices?: DeviceModelDto[];
    setAddedDevices?: (addedDevices: DeviceModelDto[]) => void;
}

const AddProduct: React.FC<ISearchProps> = (props) => {
    const { t: translate } = useTranslation();
    const { onDismiss, setDisplayScreen, addOrUpdate, setCssNumberText, addedDevices, setAddedDevices } = props;
    const cancelIcon: IIconProps = { iconName: 'Cancel' };
    const { data: getDeviceList } = useQueryAllDeviceList();
    const myRef = useRef(null);
    const [selectedProductId, setSelectedProductId] = React.useState('');
    const [selectedModel, setSelectedModel] = React.useState<DeviceModelDto[]>([]);
    const [modelsList, setModelsList] = React.useState<DeviceModelDto[]>([]);
    const modelListRef = useRef(null);
    const [cartHText, setCartHText] = React.useState(false);
    const deviceSelected = (item: DeviceCategory) => {
        setCartHText(false);
        if (selectedProductId !== item.id.toString()) {
            setSelectedProductId(item.id.toString());
            let ar = [...item.devices];
            let ex: DeviceModelDto[] = [];
            ar.forEach((ele: DeviceModel) => {
                let it = new DeviceModelDto();
                if (selectedModel.length === 0) {
                    it = new DeviceModelDto({ ...ele, categoryId: item.id, isAdded: false });
                    ex.push(it);
                } else {
                    selectedModel.every((em: DeviceModelDto) => {
                        if (em.id === ele.id) {
                            it = em;
                            return false;
                        } else {
                            it = new DeviceModelDto({ ...ele, categoryId: item.id, isAdded: false });
                            return true;
                        }
                    });
                    ex.push(it);
                }
            });

            setModelsList(ex);
        } else {
            setSelectedProductId('');
            let ex: DeviceModelDto[] = [];
            selectedModel.forEach((ele) => {
                let flag = false;
                item.devices.every((it: DeviceModel) => {
                    if (
                        it.id === ele.id &&
                        props?.selectedRequest?.deviceModels?.find((device: DeviceModelDto) => device.id === ele.id) === undefined &&
                        addOrUpdate === StringConstants.ADD &&
                        props?.addedDevices?.find((device: DeviceModelDto) => device.id === ele.id) === undefined
                    ) {
                        flag = true;
                        return false;
                    } else {
                        return true;
                    }
                });
                if (!flag) {
                    ex.push(ele);
                }
            });
            setSelectedModel(ex);
        }
    };

    const onCountChange = (e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setCartHText(false);
        selectedModel.forEach((ele: DeviceModelDto, index) => {
            if (ele.name === (e.target as HTMLInputElement | HTMLTextAreaElement).name) {
                selectedModel[index].count = parseInt((e.target as HTMLInputElement | HTMLTextAreaElement).value);
                if (!selectedModel[index].count?.toString().match(/^[0-9]*[1-9][0-9]*$/)) setCartHText(true);
            }
        });
        setSelectedModel([...selectedModel]);
    };

    const clickHandler = () => {
        setCssNumberText(false);
        setDisplayScreen('addMultiDetails');
    };

    const modelSelected = (item: DeviceModelDto, categoryIdVal: string) => {
        setCartHText(false);
        if (selectedModel.indexOf(item) === -1) {
            item.categoryId = parseInt(categoryIdVal);
            let newItem = [...selectedModel, item];
            setSelectedModel(newItem);

            if (addOrUpdate === StringConstants.ADD) {
                setAddedDevices(newItem);
            }
        } else {
            const i = selectedModel.indexOf(item);
            if (!selectedModel[i].isAdded) {
                let ar = [...selectedModel];
                ar.splice(i, 1);
                setSelectedModel(ar);

                if (addOrUpdate === StringConstants.ADD) {
                    setAddedDevices(ar);
                }
            }
        }
    };

    const addToCart = (item: DeviceModelDto) => {
        setCartHText(false);
        if (
            item.count?.toString().trim() === StringConstants.NONE ||
            item.count?.toString().trim() === undefined ||
            item.count?.toString().trim() === StringConstants.ZERO
        ) {
            setCartHText(
                item.count === undefined
                    ? true
                    : item.count?.toString() === StringConstants.NONE ||
                      item.count?.toString() === StringConstants.ZERO ||
                      !fieldValidation(item.count?.toString(), StringConstants.NUMBER, selectedModel)
                    ? true
                    : false
            );
        } else {
            const i = modelsList.indexOf(item);
            let eg = [...modelsList];
            eg[i].isAdded = true;
            setModelsList(eg);
        }
    };

    function isAdded(item: DeviceModelDto) {
        return selectedModel.filter((ele: DeviceModelDto) => ele.id === item.id).length !== 0;
    }

    const removeSelectedModel = (item: DeviceModelDto) => {
        const i = selectedModel.indexOf(item);
        let eg = [...selectedModel];
        eg[i].isAdded = false;
        setSelectedModel(eg);
        let itemRemoved = selectedModel.filter((el) => el.id !== item.id);
        setSelectedModel([...itemRemoved]);
        let zeroModels = selectedModel.filter((x) => x.isAdded && x.count === 0);
        setCartHText(zeroModels && zeroModels.length > 0 ? true : false);
    };

    useEffect(() => {
        var selectedItems: DeviceModelDto[] = [];
        if (addOrUpdate === StringConstants.ADD) {
            setSelectedModel(addedDevices);
            return;
        }
        if (getDeviceList && props.selectedRequest && (props.selectedRequest.deviceModels || props.selectedRequest.deviceModels)) {
            // if (!props.selectedRequest.devices && props.selectedRequest.deviceModels) {
            //     props.selectedRequest.devices = props.selectedRequest.deviceModels;
            // }
            props.selectedRequest.deviceModels.map((item: DeviceModelDto, index: number) => {
                let iconURL = getDeviceList
                    ?.find((product: DeviceCategory) => product.id === item.categoryId)
                    ?.devices?.find((model: DeviceModel) => model.id === item.id)?.iconUrl;
                item.count = item.deviceCount;
                item.isAdded = true;
                item.iconUrl = iconURL ? iconURL : defaultDeviceIcon;
                selectedItems.push(item);
                return item;
            });
        }
        setSelectedModel(selectedItems);
    }, [getDeviceList]);

    const update = () => {
        if (cartHText) return;

        var emptyItems = selectedModel.filter((x) => x.isAdded && (x.count === 0 || x.count === 0));
        if (emptyItems && emptyItems.length > 0) {
            setCartHText(true);
            return;
        }

        props.selectedRequest.deviceModels = [];
        selectedModel
            .filter((x) => x.isAdded)
            .forEach((item: DeviceModelDto) => {
                if (item.id === 0 || item.id.toString() === StringConstants.ZERO) {
                    getDeviceList.map((deviceList: DeviceCategory) => {
                        if (item.id !== 0 && item.id.toString() !== '0') return deviceList;
                        deviceList.devices.map((device: DeviceModel) => {
                            if (item.id !== 0 && item.id.toString() !== StringConstants.ZERO) return deviceList;
                            if (device.name === item.name) {
                                item.id = device.id;
                            }
                            return deviceList;
                        });
                        return deviceList;
                    });
                }

                props.selectedRequest.deviceModels.push(new DeviceModelDto({
                    categoryId: item.categoryId,
                    deviceCount: item.count,
                    id: item.id,
                    name: item.name,
                }));
            });

        props.handleAddProduct();
    };

    return (
        <>
            <div className="addImpact-container">
                <div>
                    <div className={`close-model `}>
                        <IconButton
                            role="button"
                            aria-label="close popup"
                            iconProps={cancelIcon}
                            ariaLabel="Close popup modal"
                            tabIndex={0}
                            onKeyPress={(e: React.KeyboardEvent<HTMLButtonElement>) => keyPress(e, onDismiss)}
                            onClick={() => onDismiss()}
                            data-testid="icon-button1"
                        />
                    </div>
                    <div className="modal-heading">
                        <span>
                            <Trans>
                                {addOrUpdate === StringConstants.UPDATE ? StringConstants.UPDATE : StringConstants.ADD} products
                            </Trans>
                        </span>
                    </div>
                    <div
                        className={`modal-body  ${
                            selectedModel && selectedModel.length > 0 && selectedModel[0]?.isAdded === true
                                ? 'custom-product-list'
                                : ''
                        }`}>
                        <div
                            className={`body-main-container bg-white ${
                                !(selectedModel && selectedModel.length > 0 && selectedModel[0]?.isAdded === true)
                                    ? 'only-product-list'
                                    : 'selected-product-list'
                            }`}>
                            <div className="product-list-header">Select the troubled product family</div>
                            <div className="products-list" ref={myRef}>
                                {getDeviceList &&
                                    getDeviceList.map((item: DeviceCategory, index: number) => {
                                        return (
                                            <>
                                                <div
                                                    aria-label={`${selectedProductId === item.id.toString() ? 'Selected Product' : ''} ${
                                                        item.name
                                                    }`}
                                                    key={item.id}
                                                    id={index.toString()}
                                                    tabIndex={0}
                                                    onClick={() => {
                                                        deviceSelected(item);
                                                    }}
                                                    onKeyPress={(e) => keyPress(e, () => deviceSelected(item))}
                                                    className={` mar-rt ${
                                                        selectedProductId === item.id.toString() ? 'selected-product' : 'device-animate'
                                                    }`}
                                                    data-testid="devicelist-div">
                                                    <Image src={getDeviceIcon(item.iconUrl)} alt="Surface" />
                                                    <Text>{item.name}</Text>
                                                </div>
                                            </>
                                        );
                                    })}
                            </div>
                            {selectedProductId && (
                                <div className={`select-model`}>
                                    <label className="device-title">
                                        <Trans>Select the troubled models</Trans>
                                    </label>
                                    <div className={`model-list-container`}>
                                        <div className="shift-icons model-list" ref={modelListRef}>
                                            {modelsList &&
                                                modelsList.length > 0 &&
                                                modelsList?.map((item: DeviceModel, i: number) => {
                                                    return (
                                                        <>
                                                            <div
                                                                aria-label={`${isAdded(item) ? 'Selected Product' : ''} ${
                                                                    item.name
                                                                }`}
                                                                key={item.name}
                                                                tabIndex={0}
                                                                onClick={(e: React.MouseEvent<HTMLDivElement>) => {
                                                                    if (
                                                                        e.target &&
                                                                        e.target !==
                                                                            document.querySelector(`#model-field-${i}`) &&
                                                                        e.target !== document.querySelector(`#add-text-${i}`)
                                                                    ) {
                                                                        modelSelected(item, selectedProductId);
                                                                    }
                                                                }}
                                                                className={`mar-rt p-b-10 ${
                                                                    isAdded(item)
                                                                        ? 'selected-product'
                                                                        : 'device-animate add-align-prop'
                                                                } ${item.isAdded ? 'isAdded' : ''}`}
                                                                data-testid="modelList-div"
                                                                onKeyPress={(e) =>
                                                                    keyPress(e, () => {
                                                                        if (
                                                                            e.target &&
                                                                            e.target !==
                                                                                document.querySelector(`#model-field-${i}`)
                                                                        ) {
                                                                            modelSelected(item, selectedProductId);
                                                                        }
                                                                    })
                                                                }>
                                                                <Image src={getDeviceIcon(item.iconUrl)} alt="Surface icon" />

                                                                <Text className="model-name">{item.name}</Text>
                                                                <div>
                                                                    {isAdded(item) && (
                                                                        <TextField
                                                                            id={`model-field-${i}`}
                                                                            onChange={onCountChange}
                                                                            placeholder={translate('Quantity')}
                                                                            name={item.name}
                                                                            value={item.count?.toString()}
                                                                            data-testid="add-text-field-test"
                                                                            type="number"
                                                                            className="regular-text-field quantity-field"
                                                                            min="0"
                                                                            autoFocus
                                                                        />
                                                                    )}

                                                                    {isAdded(item) && (
                                                                        <Text
                                                                            id={`add-text-${i}`}
                                                                            tabIndex={0}
                                                                            data-testid="add-btn-test"
                                                                            onClick={() => addToCart(item)}
                                                                            onKeyPress={(e) => keyPress(e, () => addToCart(item))}
                                                                            className="btn-add-product-modal">
                                                                            {item.isAdded ? 'Added' : 'Add'}
                                                                        </Text>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </>
                                                    );
                                                })}
                                        </div>
                                    </div>{' '}
                                </div>
                            )}
                            {cartHText && (
                                <Text className="helper-txt error-msg">
                                    <Trans>Please add the number of products.</Trans>
                                </Text>
                            )}
                        </div>
                        {selectedModel && selectedModel.length > 0 && selectedModel.find((x) => x.isAdded) && (
                            <div data-testid="cart-render-test" className="cart-section">
                                <div className="modal-cart-heading">
                                    <Trans>Added troubled devices</Trans>
                                </div>
                                <div className="cart-items-list">
                                    {selectedModel.map((item: DeviceModel) => {
                                        if (item.isAdded) {
                                            return (
                                                <div className={`item`}>
                                                    <h4>{item.name}</h4>
                                                    <div className="added-device-details">
                                                        <img src={getDeviceIcon(item.iconUrl)} alt="surface icon" />

                                                        <div className={`text-field p-r-20 p-l-20`}>
                                                            <TextField
                                                                type="number"
                                                                onChange={onCountChange}
                                                                name={item.name}
                                                                value={item.count?.toString()}
                                                            />
                                                        </div>
                                                        <div
                                                            className={`trash-icon`}
                                                            data-testid="trash-button-test"
                                                            tabIndex={0}
                                                            onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyPress(e, () => removeSelectedModel(item))}
                                                            onClick={() => removeSelectedModel(item)}>
                                                            <Icon iconName="trash" />
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        } else {
                                            return <div></div>;
                                        }
                                    })}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div
                    className={`${
                        addOrUpdate === StringConstants.UPDATE ? 'event-section-no-back-button' : 'event-section p-t-30'
                    }`}>
                    <div className={`${addOrUpdate === StringConstants.UPDATE ? 'hide' : 'back-btn'}`}>
                        <Text>
                            <Link
                                aria-label="back button"
                                tabIndex={0}
                                onClick={clickHandler}
                                onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyPress(e, clickHandler)}>
                                <span>Back</span>
                            </Link>
                        </Text>
                    </div>
                    <div className={`${selectedModel[0]?.isAdded ? 'show' : 'hide'} cancel-update-container`}>
                        <div className="cancel-btn" data-testid="cancel-modal-test" onClick={() => onDismiss()}>
                            Cancel
                        </div>
                        <DefaultButton data-testid="update-modal-test" className="default add-cust-btn" onClick={() => update()}>
                            <Text>Update</Text>
                        </DefaultButton>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddProduct;
